<template>
  <!-- Variant 1 -->
  <div
    v-if="variants.HEADER_1 === variant"
    class="navigation-header-one position-unset tw-absolute tw-left-0 tw-top-0 tw-z-50 tw-flex tw-w-full tw-bg-transparent"
    :class="{ 'scrolled !tw-fixed': isScrolled }"
    :style="`
      z-index: 9999;
      ${
        isScrolled || vars.fixedColorBool
          ? `background-color: var(--c-nav-secondary); color: var(--c-text-primary);`
          : 'background-color: transparent;'
      }
      color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-secondary)'}
    `"
  >
    <nav
      class="tw-relative tw-flex tw-w-full tw-items-center tw-justify-between tw-px-4 tw-py-4 tw-duration-300 md:tw-px-8 xl:tw-px-16 xl:tw-py-8 2xl:tw-px-32"
      :style="`
      ${
        isScrolled || vars.fixedColorBool
          ? `background-color: var(--c-nav); color: var(--c-text-primary);`
          : 'background-color: transparent;'
      }
      color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary) '};
    `"
    >
      <!-- Mobile Nav -->
      <nuxt-link to="/" class="n-link tw-max-w-6 xl:tw-hidden" :external="true">
        <div class="tw-w-16">
          <LibraryImage
            v-if="company.ls_subdomain !== 'priceestateagents'"
            :src="company.logo"
            :h-ratio="1"
            :w-ratio="1"
          />
          <LibraryImage v-else :src="company.logo" :h-ratio="1" :w-ratio="1.2" />
        </div>
      </nuxt-link>
      <div class="tw-flex tw-items-center tw-gap-10 xl:tw-hidden">
        <button
          v-if="company.ls_subdomain !== 'priceestateagents'"
          @click="toggleTheme"
          class="focus:outline-none tw-group !tw-rounded-full !tw-p-3 tw-transition-transform tw-duration-300 hover:tw-scale-95"
          style="border-color: var(--c-text-primary)"
        >
          <svg
            v-if="!isLightMode"
            class="tw-transition-transform tw-duration-300 group-hover:tw-rotate-90"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.375 3.125V1.25C9.375 1.08424 9.44085 0.925268 9.55806 0.808058C9.67527 0.690848 9.83424 0.625 10 0.625C10.1658 0.625 10.3247 0.690848 10.4419 0.808058C10.5592 0.925268 10.625 1.08424 10.625 1.25V3.125C10.625 3.29076 10.5592 3.44973 10.4419 3.56694C10.3247 3.68415 10.1658 3.75 10 3.75C9.83424 3.75 9.67527 3.68415 9.55806 3.56694C9.44085 3.44973 9.375 3.29076 9.375 3.125ZM15 10C15 10.9889 14.7068 11.9556 14.1573 12.7779C13.6079 13.6001 12.827 14.241 11.9134 14.6194C10.9998 14.9978 9.99445 15.0969 9.02455 14.9039C8.05464 14.711 7.16373 14.2348 6.46447 13.5355C5.7652 12.8363 5.289 11.9454 5.09607 10.9755C4.90315 10.0055 5.00216 9.00021 5.3806 8.08658C5.75904 7.17295 6.3999 6.39206 7.22215 5.84265C8.04439 5.29324 9.01109 5 10 5C11.3256 5.00145 12.5966 5.5287 13.5339 6.46606C14.4713 7.40343 14.9986 8.67436 15 10ZM13.75 10C13.75 9.25832 13.5301 8.5333 13.118 7.91661C12.706 7.29993 12.1203 6.81928 11.4351 6.53545C10.7498 6.25162 9.99584 6.17736 9.26841 6.32206C8.54098 6.46675 7.8728 6.8239 7.34835 7.34835C6.8239 7.8728 6.46675 8.54098 6.32206 9.26841C6.17736 9.99584 6.25162 10.7498 6.53545 11.4351C6.81928 12.1203 7.29993 12.706 7.91661 13.118C8.5333 13.5301 9.25832 13.75 10 13.75C10.9942 13.749 11.9475 13.3535 12.6505 12.6505C13.3535 11.9475 13.749 10.9942 13.75 10ZM4.55781 5.44219C4.67509 5.55946 4.83415 5.62535 5 5.62535C5.16585 5.62535 5.32491 5.55946 5.44219 5.44219C5.55946 5.32491 5.62535 5.16585 5.62535 5C5.62535 4.83415 5.55946 4.67509 5.44219 4.55781L4.19219 3.30781C4.07491 3.19054 3.91585 3.12465 3.75 3.12465C3.58415 3.12465 3.42509 3.19054 3.30781 3.30781C3.19054 3.42509 3.12465 3.58415 3.12465 3.75C3.12465 3.91585 3.19054 4.07491 3.30781 4.19219L4.55781 5.44219ZM4.55781 14.5578L3.30781 15.8078C3.19054 15.9251 3.12465 16.0841 3.12465 16.25C3.12465 16.4159 3.19054 16.5749 3.30781 16.6922C3.42509 16.8095 3.58415 16.8753 3.75 16.8753C3.91585 16.8753 4.07491 16.8095 4.19219 16.6922L5.44219 15.4422C5.50026 15.3841 5.54632 15.3152 5.57775 15.2393C5.60917 15.1634 5.62535 15.0821 5.62535 15C5.62535 14.9179 5.60917 14.8366 5.57775 14.7607C5.54632 14.6848 5.50026 14.6159 5.44219 14.5578C5.38412 14.4997 5.31518 14.4537 5.23931 14.4223C5.16344 14.3908 5.08212 14.3747 5 14.3747C4.91788 14.3747 4.83656 14.3908 4.76069 14.4223C4.68482 14.4537 4.61588 14.4997 4.55781 14.5578ZM15 5.625C15.0821 5.62506 15.1634 5.60895 15.2393 5.57759C15.3152 5.54622 15.3841 5.50021 15.4422 5.44219L16.6922 4.19219C16.8095 4.07491 16.8753 3.91585 16.8753 3.75C16.8753 3.58415 16.8095 3.42509 16.6922 3.30781C16.5749 3.19054 16.4159 3.12465 16.25 3.12465C16.0841 3.12465 15.9251 3.19054 15.8078 3.30781L14.5578 4.55781C14.4703 4.64522 14.4107 4.75663 14.3865 4.87793C14.3624 4.99924 14.3748 5.12498 14.4221 5.23924C14.4695 5.35351 14.5496 5.45116 14.6525 5.51982C14.7554 5.58849 14.8763 5.6251 15 5.625ZM15.4422 14.5578C15.3249 14.4405 15.1659 14.3747 15 14.3747C14.8341 14.3747 14.6751 14.4405 14.5578 14.5578C14.4405 14.6751 14.3747 14.8341 14.3747 15C14.3747 15.1659 14.4405 15.3249 14.5578 15.4422L15.8078 16.6922C15.8659 16.7503 15.9348 16.7963 16.0107 16.8277C16.0866 16.8592 16.1679 16.8753 16.25 16.8753C16.3321 16.8753 16.4134 16.8592 16.4893 16.8277C16.5652 16.7963 16.6341 16.7503 16.6922 16.6922C16.7503 16.6341 16.7963 16.5652 16.8277 16.4893C16.8592 16.4134 16.8753 16.3321 16.8753 16.25C16.8753 16.1679 16.8592 16.0866 16.8277 16.0107C16.7963 15.9348 16.7503 15.8659 16.6922 15.8078L15.4422 14.5578ZM3.75 10C3.75 9.83424 3.68415 9.67527 3.56694 9.55806C3.44973 9.44085 3.29076 9.375 3.125 9.375H1.25C1.08424 9.375 0.925268 9.44085 0.808058 9.55806C0.690848 9.67527 0.625 9.83424 0.625 10C0.625 10.1658 0.690848 10.3247 0.808058 10.4419C0.925268 10.5592 1.08424 10.625 1.25 10.625H3.125C3.29076 10.625 3.44973 10.5592 3.56694 10.4419C3.68415 10.3247 3.75 10.1658 3.75 10ZM10 16.25C9.83424 16.25 9.67527 16.3158 9.55806 16.4331C9.44085 16.5503 9.375 16.7092 9.375 16.875V18.75C9.375 18.9158 9.44085 19.0747 9.55806 19.1919C9.67527 19.3092 9.83424 19.375 10 19.375C10.1658 19.375 10.3247 19.3092 10.4419 19.1919C10.5592 19.0747 10.625 18.9158 10.625 18.75V16.875C10.625 16.7092 10.5592 16.5503 10.4419 16.4331C10.3247 16.3158 10.1658 16.25 10 16.25ZM18.75 9.375H16.875C16.7092 9.375 16.5503 9.44085 16.4331 9.55806C16.3158 9.67527 16.25 9.83424 16.25 10C16.25 10.1658 16.3158 10.3247 16.4331 10.4419C16.5503 10.5592 16.7092 10.625 16.875 10.625H18.75C18.9158 10.625 19.0747 10.5592 19.1919 10.4419C19.3092 10.3247 19.375 10.1658 19.375 10C19.375 9.83424 19.3092 9.67527 19.1919 9.55806C19.0747 9.44085 18.9158 9.375 18.75 9.375Z"
              fill="var(--c-text-primary)"
            />
          </svg>
          <svg v-else width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.1352 10.2218C16.075 10.1617 15.9995 10.1191 15.917 10.0986C15.8344 10.0781 15.7478 10.0805 15.6664 10.1054C14.4477 10.4738 13.1518 10.5046 11.9169 10.1945C10.682 9.88445 9.55439 9.24514 8.65421 8.34471C7.75402 7.44428 7.11501 6.31649 6.80527 5.08152C6.49552 3.84655 6.52666 2.55067 6.89535 1.332C6.91998 1.25073 6.92207 1.1643 6.9014 1.08194C6.88073 0.999575 6.83807 0.924373 6.77799 0.864367C6.7179 0.804361 6.64264 0.761805 6.56025 0.741243C6.47786 0.720682 6.39143 0.722888 6.3102 0.747627C4.69423 1.2434 3.27569 2.23602 2.25629 3.58435C1.10071 5.11879 0.538301 7.01901 0.67258 8.93522C0.80686 10.8514 1.62879 12.6546 2.98708 14.0129C4.34537 15.3712 6.14858 16.1931 8.06479 16.3274C9.98099 16.4617 11.8812 15.8993 13.4157 14.7437C14.764 13.7243 15.7566 12.3058 16.2524 10.6898C16.2771 10.6085 16.2793 10.522 16.2586 10.4396C16.238 10.3572 16.1953 10.2819 16.1352 10.2218ZM12.8539 13.9945C11.4999 15.01 9.82503 15.503 8.13676 15.3831C6.44849 15.2631 4.86015 14.5381 3.66335 13.3413C2.46655 12.1445 1.74162 10.5562 1.62163 8.86794C1.50165 7.17967 1.99468 5.50477 3.0102 4.15075C3.73352 3.19171 4.68829 2.43181 5.7852 1.94216C5.55426 3.21061 5.63437 4.51615 6.01866 5.74685C6.40294 6.97756 7.07994 8.09672 7.99162 9.00839C8.90329 9.92007 10.0225 10.5971 11.2532 10.9814C12.4839 11.3656 13.7894 11.4457 15.0579 11.2148C14.5695 12.3132 13.8104 13.2696 12.8516 13.9945H12.8539Z"
              fill="var(--c-text-primary)"
            />
          </svg>
        </button>
        <button
          v-if="company.ls_subdomain !== 'priceestateagents'"
          class="focus:outline-none !tw-p-0"
          id="menu-button"
          @click="toggleMenu"
        >
          <svg width="28" height="18" viewBox="0 0 28 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.5 18V15H27.5V18H0.5ZM0.5 10.5V7.5H27.5V10.5H0.5ZM0.5 3V0H27.5V3H0.5Z"
              fill="var(--c-hamburger-nav)"
            />
          </svg>
        </button>
        <button
          v-else
          class="focus:outline-none !tw-p-3"
          style="background-color: #0d0335 !important"
          id="menu-button"
          @click="toggleMenu"
        >
          <svg width="28" height="18" viewBox="0 0 28 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.5 18V15H27.5V18H0.5ZM0.5 10.5V7.5H27.5V10.5H0.5ZM0.5 3V0H27.5V3H0.5Z"
              fill="var(--c-hamburger-nav)"
            />
          </svg>
        </button>
      </div>
      <!-- Mobile Nav End -->

      <!-- Desktop Nav -->
      <button
        v-if="company.ls_subdomain !== 'priceestateagents'"
        @click="toggleTheme"
        class="focus:outline-none tw-group tw-z-10 tw-hidden !tw-rounded-full !tw-p-3 tw-transition-all tw-duration-300 hover:tw-scale-95 xl:tw-flex"
        style="border-color: var(--c-text-primary)"
      >
        <svg
          v-if="!isLightMode"
          class="tw-transition-transform tw-duration-300 group-hover:tw-rotate-90"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.375 3.125V1.25C9.375 1.08424 9.44085 0.925268 9.55806 0.808058C9.67527 0.690848 9.83424 0.625 10 0.625C10.1658 0.625 10.3247 0.690848 10.4419 0.808058C10.5592 0.925268 10.625 1.08424 10.625 1.25V3.125C10.625 3.29076 10.5592 3.44973 10.4419 3.56694C10.3247 3.68415 10.1658 3.75 10 3.75C9.83424 3.75 9.67527 3.68415 9.55806 3.56694C9.44085 3.44973 9.375 3.29076 9.375 3.125ZM15 10C15 10.9889 14.7068 11.9556 14.1573 12.7779C13.6079 13.6001 12.827 14.241 11.9134 14.6194C10.9998 14.9978 9.99445 15.0969 9.02455 14.9039C8.05464 14.711 7.16373 14.2348 6.46447 13.5355C5.7652 12.8363 5.289 11.9454 5.09607 10.9755C4.90315 10.0055 5.00216 9.00021 5.3806 8.08658C5.75904 7.17295 6.3999 6.39206 7.22215 5.84265C8.04439 5.29324 9.01109 5 10 5C11.3256 5.00145 12.5966 5.5287 13.5339 6.46606C14.4713 7.40343 14.9986 8.67436 15 10ZM13.75 10C13.75 9.25832 13.5301 8.5333 13.118 7.91661C12.706 7.29993 12.1203 6.81928 11.4351 6.53545C10.7498 6.25162 9.99584 6.17736 9.26841 6.32206C8.54098 6.46675 7.8728 6.8239 7.34835 7.34835C6.8239 7.8728 6.46675 8.54098 6.32206 9.26841C6.17736 9.99584 6.25162 10.7498 6.53545 11.4351C6.81928 12.1203 7.29993 12.706 7.91661 13.118C8.5333 13.5301 9.25832 13.75 10 13.75C10.9942 13.749 11.9475 13.3535 12.6505 12.6505C13.3535 11.9475 13.749 10.9942 13.75 10ZM4.55781 5.44219C4.67509 5.55946 4.83415 5.62535 5 5.62535C5.16585 5.62535 5.32491 5.55946 5.44219 5.44219C5.55946 5.32491 5.62535 5.16585 5.62535 5C5.62535 4.83415 5.55946 4.67509 5.44219 4.55781L4.19219 3.30781C4.07491 3.19054 3.91585 3.12465 3.75 3.12465C3.58415 3.12465 3.42509 3.19054 3.30781 3.30781C3.19054 3.42509 3.12465 3.58415 3.12465 3.75C3.12465 3.91585 3.19054 4.07491 3.30781 4.19219L4.55781 5.44219ZM4.55781 14.5578L3.30781 15.8078C3.19054 15.9251 3.12465 16.0841 3.12465 16.25C3.12465 16.4159 3.19054 16.5749 3.30781 16.6922C3.42509 16.8095 3.58415 16.8753 3.75 16.8753C3.91585 16.8753 4.07491 16.8095 4.19219 16.6922L5.44219 15.4422C5.50026 15.3841 5.54632 15.3152 5.57775 15.2393C5.60917 15.1634 5.62535 15.0821 5.62535 15C5.62535 14.9179 5.60917 14.8366 5.57775 14.7607C5.54632 14.6848 5.50026 14.6159 5.44219 14.5578C5.38412 14.4997 5.31518 14.4537 5.23931 14.4223C5.16344 14.3908 5.08212 14.3747 5 14.3747C4.91788 14.3747 4.83656 14.3908 4.76069 14.4223C4.68482 14.4537 4.61588 14.4997 4.55781 14.5578ZM15 5.625C15.0821 5.62506 15.1634 5.60895 15.2393 5.57759C15.3152 5.54622 15.3841 5.50021 15.4422 5.44219L16.6922 4.19219C16.8095 4.07491 16.8753 3.91585 16.8753 3.75C16.8753 3.58415 16.8095 3.42509 16.6922 3.30781C16.5749 3.19054 16.4159 3.12465 16.25 3.12465C16.0841 3.12465 15.9251 3.19054 15.8078 3.30781L14.5578 4.55781C14.4703 4.64522 14.4107 4.75663 14.3865 4.87793C14.3624 4.99924 14.3748 5.12498 14.4221 5.23924C14.4695 5.35351 14.5496 5.45116 14.6525 5.51982C14.7554 5.58849 14.8763 5.6251 15 5.625ZM15.4422 14.5578C15.3249 14.4405 15.1659 14.3747 15 14.3747C14.8341 14.3747 14.6751 14.4405 14.5578 14.5578C14.4405 14.6751 14.3747 14.8341 14.3747 15C14.3747 15.1659 14.4405 15.3249 14.5578 15.4422L15.8078 16.6922C15.8659 16.7503 15.9348 16.7963 16.0107 16.8277C16.0866 16.8592 16.1679 16.8753 16.25 16.8753C16.3321 16.8753 16.4134 16.8592 16.4893 16.8277C16.5652 16.7963 16.6341 16.7503 16.6922 16.6922C16.7503 16.6341 16.7963 16.5652 16.8277 16.4893C16.8592 16.4134 16.8753 16.3321 16.8753 16.25C16.8753 16.1679 16.8592 16.0866 16.8277 16.0107C16.7963 15.9348 16.7503 15.8659 16.6922 15.8078L15.4422 14.5578ZM3.75 10C3.75 9.83424 3.68415 9.67527 3.56694 9.55806C3.44973 9.44085 3.29076 9.375 3.125 9.375H1.25C1.08424 9.375 0.925268 9.44085 0.808058 9.55806C0.690848 9.67527 0.625 9.83424 0.625 10C0.625 10.1658 0.690848 10.3247 0.808058 10.4419C0.925268 10.5592 1.08424 10.625 1.25 10.625H3.125C3.29076 10.625 3.44973 10.5592 3.56694 10.4419C3.68415 10.3247 3.75 10.1658 3.75 10ZM10 16.25C9.83424 16.25 9.67527 16.3158 9.55806 16.4331C9.44085 16.5503 9.375 16.7092 9.375 16.875V18.75C9.375 18.9158 9.44085 19.0747 9.55806 19.1919C9.67527 19.3092 9.83424 19.375 10 19.375C10.1658 19.375 10.3247 19.3092 10.4419 19.1919C10.5592 19.0747 10.625 18.9158 10.625 18.75V16.875C10.625 16.7092 10.5592 16.5503 10.4419 16.4331C10.3247 16.3158 10.1658 16.25 10 16.25ZM18.75 9.375H16.875C16.7092 9.375 16.5503 9.44085 16.4331 9.55806C16.3158 9.67527 16.25 9.83424 16.25 10C16.25 10.1658 16.3158 10.3247 16.4331 10.4419C16.5503 10.5592 16.7092 10.625 16.875 10.625H18.75C18.9158 10.625 19.0747 10.5592 19.1919 10.4419C19.3092 10.3247 19.375 10.1658 19.375 10C19.375 9.83424 19.3092 9.67527 19.1919 9.55806C19.0747 9.44085 18.9158 9.375 18.75 9.375Z"
            fill="var(--c-text-primary)"
          />
        </svg>
        <svg v-else width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.1352 10.2218C16.075 10.1617 15.9995 10.1191 15.917 10.0986C15.8344 10.0781 15.7478 10.0805 15.6664 10.1054C14.4477 10.4738 13.1518 10.5046 11.9169 10.1945C10.682 9.88445 9.55439 9.24514 8.65421 8.34471C7.75402 7.44428 7.11501 6.31649 6.80527 5.08152C6.49552 3.84655 6.52666 2.55067 6.89535 1.332C6.91998 1.25073 6.92207 1.1643 6.9014 1.08194C6.88073 0.999575 6.83807 0.924373 6.77799 0.864367C6.7179 0.804361 6.64264 0.761805 6.56025 0.741243C6.47786 0.720682 6.39143 0.722888 6.3102 0.747627C4.69423 1.2434 3.27569 2.23602 2.25629 3.58435C1.10071 5.11879 0.538301 7.01901 0.67258 8.93522C0.80686 10.8514 1.62879 12.6546 2.98708 14.0129C4.34537 15.3712 6.14858 16.1931 8.06479 16.3274C9.98099 16.4617 11.8812 15.8993 13.4157 14.7437C14.764 13.7243 15.7566 12.3058 16.2524 10.6898C16.2771 10.6085 16.2793 10.522 16.2586 10.4396C16.238 10.3572 16.1953 10.2819 16.1352 10.2218ZM12.8539 13.9945C11.4999 15.01 9.82503 15.503 8.13676 15.3831C6.44849 15.2631 4.86015 14.5381 3.66335 13.3413C2.46655 12.1445 1.74162 10.5562 1.62163 8.86794C1.50165 7.17967 1.99468 5.50477 3.0102 4.15075C3.73352 3.19171 4.68829 2.43181 5.7852 1.94216C5.55426 3.21061 5.63437 4.51615 6.01866 5.74685C6.40294 6.97756 7.07994 8.09672 7.99162 9.00839C8.90329 9.92007 10.0225 10.5971 11.2532 10.9814C12.4839 11.3656 13.7894 11.4457 15.0579 11.2148C14.5695 12.3132 13.8104 13.2696 12.8516 13.9945H12.8539Z"
            fill="var(--c-text-primary)"
          />
        </svg>
      </button>
      <div
        class="tw-absolute tw-left-1/2 tw-top-0 tw-hidden tw-h-full tw-w-full tw--translate-x-1/2 tw-items-center tw-justify-center tw-gap-12 xl:tw-flex"
      >
        <div class="tw-hidden tw-w-full xl:tw-block">
          <ul class="tw-flex tw-w-full tw-justify-end tw-gap-8 tw-align-middle">
            <li
              v-for="(menuGroup, groupIndex) in leftMenu"
              :key="`menuGroupIndex-${groupIndex}`"
              class="navigation-element tw-group tw-relative tw-py-8 tw-duration-300"
              :class="isScrolled ? '!tw-text-[var(--c-text-primary)]' : routeUrl === '/' ? '!tw-text-white' : ''"
            >
              <div class="tw-flex tw-items-center tw-justify-center">
                <nuxt-link
                  :external="true"
                  :to="menuGroup.url"
                  :target="menuGroup.is_open_new_tab ? '_blank' : ''"
                  class="n-link tw-duration-300 hover:tw-text-[var(--c-primary)]"
                >
                  <p class="!tw-font-semibold">{{ menuGroup.name }}</p>
                </nuxt-link>
              </div>
              <ul
                v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
                class="sub_menu tw-pointer-events-none tw-absolute tw-mt-8 tw-max-h-0 tw-rounded-sm tw-border-[1px] tw-px-6 tw-py-4 tw-text-left tw-opacity-0 tw-duration-700 group-hover:tw-pointer-events-auto group-hover:tw-max-h-[700px] group-hover:!tw-opacity-100"
                :style="`box-shadow: var(--c-box_shadow) ;border-radius: var(--rounded); background-color: var(--c-nav);color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}; transition-delay:.2s`"
              >
                <li
                  v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
                  :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                  class="tw-w-[220px] tw-py-4"
                  style="border-color: var(--c-border)"
                >
                  <nuxt-link
                    class="n-link tw-block tw-px-4 tw-py-2 tw-duration-300 hover:tw-ml-4 hover:!tw-text-[var(--c-primary)]"
                    :external="true"
                    :to="subMenu.url"
                    :target="subMenu.is_open_new_tab ? '_blank' : ''"
                    :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
                  >
                    <p class="!tw-font-semibold">{{ subMenu.name }}</p>
                  </nuxt-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div v-if="company.ls_subdomain !== 'priceestateagents'" class="tw-hidden tw-w-16 tw-flex-none xl:tw-block">
          <nuxt-link to="/" class="n-link" :external="true">
            <LibraryImage :src="company.logo" :h-ratio="1" :w-ratio="1" />
          </nuxt-link>
        </div>
        <div v-else class="tw-hidden tw-flex-none xl:tw-block">
          <nuxt-link to="/" class="n-link" :external="true">
            <NuxtImg :src="company.logo" :width="120" />
          </nuxt-link>
        </div>
        <div class="tw-hidden tw-w-full xl:tw-block">
          <ul class="tw-flex tw-w-full tw-justify-start tw-gap-8 tw-align-middle">
            <li
              v-for="(menuGroup, groupIndex) in rightMenu"
              :key="`menuGroupIndex-${groupIndex}`"
              class="navigation-element tw-group tw-relative tw-py-8 tw-duration-300"
              :class="isScrolled ? '!tw-text-[var(--c-text-primary)]' : routeUrl === '/' ? '!tw-text-white' : ''"
            >
              <div class="tw-flex tw-items-center tw-justify-center">
                <nuxt-link
                  :external="true"
                  :to="menuGroup.url"
                  :target="menuGroup.is_open_new_tab ? '_blank' : ''"
                  class="n-link tw-duration-300 hover:tw-text-[var(--c-primary)]"
                >
                  <p class="!tw-font-semibold">{{ menuGroup.name }}</p>
                </nuxt-link>
              </div>
              <ul
                v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
                class="sub_menu tw-pointer-events-none tw-absolute tw-mt-8 tw-max-h-0 tw-rounded-sm tw-border-[1px] tw-px-6 tw-py-4 tw-text-left tw-opacity-0 tw-duration-700 group-hover:tw-pointer-events-auto group-hover:tw-max-h-[700px] group-hover:!tw-opacity-100"
                :style="`box-shadow: var(--c-box_shadow) ;border-radius: var(--rounded); background-color: var(--c-nav);color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}; `"
              >
                <li
                  v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
                  :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                  class="tw-w-[220px] tw-py-4"
                  style="border-color: var(--c-border)"
                >
                  <nuxt-link
                    class="n-link tw-block tw-px-4 tw-py-2 tw-duration-300 hover:!tw-text-[var(--c-primary)]"
                    :external="true"
                    :to="subMenu.url"
                    :target="subMenu.is_open_new_tab ? '_blank' : ''"
                    :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
                  >
                    <p class="!tw-font-semibold">{{ subMenu.name }}</p>
                  </nuxt-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="tw-z-10 tw-ml-auto tw-hidden xl:tw-block">
        <nuxt-link
          :to="vars.buttonLinkUrl"
          :external="true"
          :class="`n-${vars.buttonTypeText} n-btn tw-group !tw-text-[var(--c-text-primary)]`"
        >
          <div class="contact-button n-btn-container group-hover:tw-text-white">
            <div class="n-btn-group">
              <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
              <div class="n-btn-t2">{{ vars.buttonLabelText }}</div>
            </div>
          </div>
        </nuxt-link>
      </div>
    </nav>
  </div>

  <!-- Variant 2-->
  <div
    v-if="variants.HEADER_2 === variant"
    class="position-unset navbar tw-absolute tw-left-0 tw-top-0 tw-z-50 tw-flex tw-w-full tw-items-center tw-justify-between !tw-bg-opacity-90 tw-px-6 tw-py-1 tw-transition-all tw-duration-300 md:tw-px-20 xl:tw-px-32"
    :class="{ 'scrolled !tw-fixed': isScrolled }"
    :style="`
      ${
        isScrolled || vars.fixedColorBool
          ? `background-color: var(--c-nav-secondary); color: var(--c-text-primary);`
          : 'background-color: transparent;'
      }
      color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary) '};
      z-index: 1001;
    `"
  >
    <nuxt-link to="/" :external="true" class="n-link tw-max-w-6">
      <template v-if="company.company_key === 'brianmcg'">
        <div class="tw-w-48">
          <img :src="logo" :style="`width: 100%; height: 48px;`" />
        </div>
      </template>
      <template v-else>
        <div class="tw-w-24">
          <LibraryImage :src="logo" :h-ratio="1" :w-ratio="1.2" />
        </div>
      </template>
    </nuxt-link>
    <button
      class="icon burger-menu tw-border-[1px]"
      @click="toggleActiveClass"
      :style="`${isScrolled || vars.fixedColorBool ? `border-color: var(--c-${vars.navTextColor}); color: var(--c-${vars.navTextColor}) !important` : 'border-color: var(--white); color: var(--white)'};`"
    >
      <span
        :style="`${isScrolled || vars.fixedColorBool ? `background: var(--c-${vars.navTextColor})` : 'background: var(--c-nav-secondary)'}`"
      ></span>
      <span
        :style="`${isScrolled || vars.fixedColorBool ? `background: var(--c-${vars.navTextColor})` : 'background: var(--c-nav-secondary)'}`"
      ></span>
    </button>
  </div>

  <div
    v-if="variants.HEADER_2 === variant"
    class="nav-menu tw-fixed tw-inset-0 tw-z-40 tw-flex tw-items-center tw-justify-center tw-overflow-y-auto !tw-bg-opacity-90"
    style="background-color: var(--c-primary_transparent)"
  >
    <div class="tw-flex tw-h-[70vh] tw-items-center tw-justify-center tw-overflow-auto xl:tw-h-screen">
      <nav
        class="tw-max-h-full tw-overflow-auto tw-pb-[20%] lg:tw-pb-32"
        :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--white)'}`"
      >
        <ul class="tw-flex tw-flex-col tw-gap-6">
          <li
            v-for="(menuGroup, groupIndex) in allMenu[0]"
            :key="`menuGroupIndex-${groupIndex}`"
            class="nav-item tw-group tw-relative tw-duration-300"
            :style="`animation-delay: ${groupIndex * 0.2}s;`"
          >
            <div class="tw-flex tw-items-center tw-justify-center" @click="toggleSubMenu(groupIndex)">
              <nuxt-link
                :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
                :target="menuGroup.is_open_new_tab ? '_blank' : ''"
                :external="true"
                class="n-link tw-duration-400 tw-text-center hover:tw-text-[var(--c-secondary)]"
              >
                <h2>{{ menuGroup.name }}</h2>
              </nuxt-link>
            </div>
            <ul
              v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
              class="tw-overflow-hidden tw-transition-all tw-duration-1000 tw-ease-in-out"
              :class="openSubMenu === groupIndex ? 'tw-max-h-96' : 'tw-max-h-0'"
            >
              <li
                v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
                :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                class="tw-pb-2 tw-pt-0 tw-text-center"
              >
                <nuxt-link
                  class="n-link tw-block tw-duration-300 hover:!tw-text-[var(--c-secondary)]"
                  :external="true"
                  :to="subMenu.url"
                  :target="subMenu.is_open_new_tab ? '_blank' : ''"
                  :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--white)'}`"
                >
                  <h6>{{ subMenu.name }}</h6>
                </nuxt-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <!-- Variant 3-->
  <div
    v-if="variants.HEADER_3 === variant"
    class="position-unset navbar tw-absolute tw-left-0 tw-top-0 tw-z-50 tw-flex tw-w-full tw-items-center tw-justify-between !tw-bg-opacity-90 tw-px-6 tw-py-6 tw-transition-all tw-duration-300 md:tw-px-20 xl:tw-px-32"
    :class="{ 'scrolled !tw-fixed': isScrolled }"
    :style="`
    ${
      isScrolled || vars.fixedColorBool
        ? 'background-color: var(--white); color: var(--c-text-primary);'
        : 'background-color: transparent;'
    }
    color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'};
    z-index: 1001;
  `"
  >
    <!-- Sol Butonlar - Menü açıksa gizle -->
    <div v-if="!menuVisible" class="tw-hidden tw-gap-4 lg:tw-flex">
      <nuxt-link
        v-for="(button, index) in buttons"
        :key="`button-${index}`"
        :class="[buttons.length >= 2 ? '' : 'tw-w-auto', `n-${button.button_type}`, 'tw-uppercase']"
        :to="button.button_link || '/'"
        :external="true"
      >
        {{ button.button_label }}
      </nuxt-link>
    </div>

    <!-- Logo -->
    <nuxt-link
      to="/"
      :external="true"
      :class="[
        'n-link tw-transition-all tw-duration-1000 tw-ease-in-out',
        menuVisible ? 'tw-relative tw-left-0 tw-translate-x-0' : 'md:tw-absolute md:tw-left-1/2 md:tw--translate-x-1/2',
      ]"
    >
      <template v-if="company.company_key === 'harrisonshomes'">
        <div class="tw-w-40 md:tw-w-64">
          <img :src="logo" :style="`width: 100%;`" />
        </div>
      </template>
      <template v-else>
        <div class="tw-w-64 tw-max-w-56">
          <LibraryImage :src="logo" :h-ratio="1" :w-ratio="4" />
        </div>
      </template>
    </nuxt-link>

    <!-- Sağ Burger Menü -->
    <button
      class="icon burger-menu tw-border-[1px]"
      @click="toggleActiveClass"
      :style="`${
        isScrolled || vars.fixedColorBool || routeUrl !== '/'
          ? `border-color: var(--c-${vars.navTextColor}); color: var(--c-${vars.navTextColor}) !important`
          : 'border-color: var(--white); color: var(--white) !important'
      };`"
    >
      <span
        :style="`${
          isScrolled || vars.fixedColorBool || routeUrl !== '/'
            ? `background: var(--c-${vars.navTextColor})`
            : 'background: var(--white)'
        }`"
      ></span>
      <span
        :style="`${
          isScrolled || vars.fixedColorBool || routeUrl !== '/'
            ? `background: var(--c-${vars.navTextColor})`
            : 'background: var(--white)'
        }`"
      ></span>
    </button>
  </div>

  <div
    v-if="variants.HEADER_3 === variant"
    class="nav-menu tw-fixed tw-inset-0 tw-z-40 tw-flex tw-items-center tw-justify-center tw-overflow-y-auto !tw-bg-opacity-90"
    :style="`background-image: url('${vars.backgroundImage}'); background-size: cover; background-position: center`"
  >
    <div class="tw-flex tw-h-[70vh] tw-items-center tw-justify-center tw-overflow-auto xl:tw-h-screen">
      <nav
        class="tw-max-h-full tw-overflow-auto tw-pb-[20%] lg:tw-pb-32"
        :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--white)'}`"
      >
        <ul class="tw-flex tw-flex-col tw-gap-6">
          <li
            v-for="(menuGroup, groupIndex) in allMenu[0]"
            :key="`menuGroupIndex-${groupIndex}`"
            class="nav-item tw-group tw-relative tw-duration-300"
            :style="`animation-delay: ${groupIndex * 0.2}s;`"
          >
            <div class="tw-flex tw-items-center tw-justify-center" @click="toggleSubMenu(groupIndex)">
              <nuxt-link
                :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
                :target="menuGroup.is_open_new_tab ? '_blank' : ''"
                :external="true"
                class="n-link tw-duration-400 tw-text-center hover:tw-text-[var(--c-secondary)]"
              >
                <h2>{{ menuGroup.name }}</h2>
              </nuxt-link>
            </div>
            <ul
              v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
              class="tw-overflow-hidden tw-transition-all tw-duration-1000 tw-ease-in-out"
              :class="openSubMenu === groupIndex ? 'tw-max-h-96' : 'tw-max-h-0'"
            >
              <li
                v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
                :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                class="tw-pb-2 tw-pt-0 tw-text-center"
              >
                <nuxt-link
                  class="n-link tw-block tw-duration-300 hover:!tw-text-[var(--c-secondary)]"
                  :external="true"
                  :to="subMenu.url"
                  :target="subMenu.is_open_new_tab ? '_blank' : ''"
                  :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--white)'}`"
                >
                  <h6>{{ subMenu.name }}</h6>
                </nuxt-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <!-- Mobile Menu Dark Overlay -->
  <div
    v-if="menuVisible && variants.HEADER_1 === variant"
    class="tw-fixed tw-inset-0 tw-z-50 tw-bg-black tw-bg-opacity-50"
    @click="toggleMenu"
  ></div>

  <!-- Mobile Menu V1-->
  <div
    v-if="variants.HEADER_1 === variant"
    class="tw-fixed tw-right-0 tw-top-0 tw-z-[9999] tw-h-full tw-w-[310px] tw-overflow-y-auto tw-duration-300"
    :class="menuVisible ? '-tw-translate-x-0' : 'tw-translate-x-[101%]'"
    :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}; background-color: var(--c-nav)`"
  >
    <div class="tw-px-6 tw-pt-10">
      <div v-if="company.ls_subdomain !== 'priceestateagents'" class="tw-flex tw-items-center tw-justify-end">
        <span
          @click="toggleMenu"
          class="tw-group tw-cursor-pointer"
          :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'};`"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            class="tw-transition-transform tw-duration-300 group-hover:tw-rotate-90"
          >
            <path
              d="M15.2806 14.2193C15.3502 14.289 15.4055 14.3717 15.4432 14.4628C15.4809 14.5538 15.5003 14.6514 15.5003 14.7499C15.5003 14.8485 15.4809 14.9461 15.4432 15.0371C15.4055 15.1281 15.3502 15.2109 15.2806 15.2806C15.2109 15.3502 15.1281 15.4055 15.0371 15.4432C14.9461 15.4809 14.8485 15.5003 14.7499 15.5003C14.6514 15.5003 14.5538 15.4809 14.4628 15.4432C14.3717 15.4055 14.289 15.3502 14.2193 15.2806L7.99993 9.06024L1.78055 15.2806C1.63982 15.4213 1.44895 15.5003 1.24993 15.5003C1.05091 15.5003 0.860034 15.4213 0.719304 15.2806C0.578573 15.1398 0.499512 14.949 0.499512 14.7499C0.499512 14.5509 0.578573 14.36 0.719304 14.2193L6.93962 7.99993L0.719304 1.78055C0.578573 1.63982 0.499512 1.44895 0.499512 1.24993C0.499512 1.05091 0.578573 0.860034 0.719304 0.719304C0.860034 0.578573 1.05091 0.499512 1.24993 0.499512C1.44895 0.499512 1.63982 0.578573 1.78055 0.719304L7.99993 6.93962L14.2193 0.719304C14.36 0.578573 14.5509 0.499512 14.7499 0.499512C14.949 0.499512 15.1398 0.578573 15.2806 0.719304C15.4213 0.860034 15.5003 1.05091 15.5003 1.24993C15.5003 1.44895 15.4213 1.63982 15.2806 1.78055L9.06024 7.99993L15.2806 14.2193Z"
              :fill="vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'"
            ></path>
          </svg>
        </span>
      </div>
      <div v-else class="tw-flex tw-items-center tw-justify-end">
        <span @click="toggleMenu" class="tw-group tw-cursor-pointer" :style="`color: var(--c-text-primary)`">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            class="tw-transition-transform tw-duration-300 group-hover:tw-rotate-90"
          >
            <path
              d="M15.2806 14.2193C15.3502 14.289 15.4055 14.3717 15.4432 14.4628C15.4809 14.5538 15.5003 14.6514 15.5003 14.7499C15.5003 14.8485 15.4809 14.9461 15.4432 15.0371C15.4055 15.1281 15.3502 15.2109 15.2806 15.2806C15.2109 15.3502 15.1281 15.4055 15.0371 15.4432C14.9461 15.4809 14.8485 15.5003 14.7499 15.5003C14.6514 15.5003 14.5538 15.4809 14.4628 15.4432C14.3717 15.4055 14.289 15.3502 14.2193 15.2806L7.99993 9.06024L1.78055 15.2806C1.63982 15.4213 1.44895 15.5003 1.24993 15.5003C1.05091 15.5003 0.860034 15.4213 0.719304 15.2806C0.578573 15.1398 0.499512 14.949 0.499512 14.7499C0.499512 14.5509 0.578573 14.36 0.719304 14.2193L6.93962 7.99993L0.719304 1.78055C0.578573 1.63982 0.499512 1.44895 0.499512 1.24993C0.499512 1.05091 0.578573 0.860034 0.719304 0.719304C0.860034 0.578573 1.05091 0.499512 1.24993 0.499512C1.44895 0.499512 1.63982 0.578573 1.78055 0.719304L7.99993 6.93962L14.2193 0.719304C14.36 0.578573 14.5509 0.499512 14.7499 0.499512C14.949 0.499512 15.1398 0.578573 15.2806 0.719304C15.4213 0.860034 15.5003 1.05091 15.5003 1.24993C15.5003 1.44895 15.4213 1.63982 15.2806 1.78055L9.06024 7.99993L15.2806 14.2193Z"
              :fill="`var(--c-text-primary)`"
            ></path>
          </svg>
        </span>
      </div>
    </div>

    <ul class="tw-flex tw-flex-col tw-pt-8">
      <li v-for="(menuGroup, groupIndex) in allMenu[0]" :key="`menuGroupIndex-${groupIndex}`" class="tw-w-full tw-px-6">
        <div
          class="tw-flex tw-w-full tw-items-center tw-justify-between tw-pb-3 tw-pt-0"
          @click="toggleSubMenu(groupIndex)"
        >
          <nuxt-link
            :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
            :target="menuGroup.is_open_new_tab ? '_blank' : ''"
            :external="true"
            class="mobile-menu-link tw-uppercase tw-duration-300 hover:tw-text-[var(--c-primary)]"
            :class="`hover:tw-text-[var(--c-${vars.hoverTextColor})]`"
          >
            {{ menuGroup.name }}
          </nuxt-link>
          <div
            class="tw-flex tw-cursor-pointer tw-items-center tw-rounded tw-bg-transparent tw-p-2"
            v-if="menuGroup.has_sub_menu"
          >
            <span
              class="nc-icon-chevron-down sub-menu-arrow theme3-menu-link tw-duration-500"
              :class="{ 'tw-rotate-180': openSubMenu === groupIndex }"
            ></span>
          </div>
        </div>
        <ul
          v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
          class="tw-ml-6 tw-overflow-hidden tw-transition-all tw-duration-500"
          :class="openSubMenu === groupIndex ? 'tw-max-h-96' : 'tw-max-h-0'"
        >
          <li
            v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
            :key="`${subMenuIndex}-subMenu-${groupIndex}`"
            class="tw-pb-6 tw-pt-0"
          >
            <nuxt-link
              :to="subMenu.url"
              :target="subMenu.is_open_new_tab ? '_blank' : ''"
              class="n-link hover:tw-text-[var(--c-primary)]"
              :external="true"
              :class="`tw-duration-300 hover:tw-text-[var(--c-${vars.hoverTextColor})]`"
            >
              {{ subMenu.name }}
            </nuxt-link>
          </li>
        </ul>
      </li>
      <li class="tw-w-full tw-px-6 tw-pt-6" v-if="vars.buttonLabelText">
        <nuxt-link :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText} n-btn`" :external="true">
          <div class="n-btn-container">
            <div class="n-btn-group">
              <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
              <div class="n-btn-t2">{{ vars.buttonLabelText }}</div>
            </div>
          </div>
        </nuxt-link>
      </li>
    </ul>
    <nuxt-link></nuxt-link>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { MenuTypes, ViewTypes } from '~/constants/ui.constants';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';
import { useCoreStore } from '~/units/core/store';

type Menu = {};

export default defineNuxtComponent({
  name: 'Theme6BaseHeaderOne',

  mixins: [ComponentMixin],

  props: {
    component: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      ViewTypes,
      menuVisible: false,
      isScrolled: false,
      openSubMenu: null,
      variants: {
        HEADER_1: 'HEADER_1',
        HEADER_2: 'HEADER_2',
        HEADER_3: 'HEADER_3',
      },
      isActive: false,
      scrollThreshold: 350,
      isLightMode: false,
      isMenuOpen: false,
      scrollPosition: 0,
    };
  },

  computed: {
    ...mapState(useWebsiteStore, ['headerMenuItems']),
    ...mapState(useCoreStore, ['isAnythingOnTopVisible']),

    headerMenu() {
      return this.headerMenuItems as Menu[];
    },
    buttons(): any[] {
      return this.groupedVariables.buttons || [];
    },

    routeUrl() {
      const route = useRoute();
      return route.path;
    },

    allMenu() {
      const period = 9;
      const columnsCount = Math.ceil(this.columnOneMenu.length / period);
      const groups = [];

      for (let i = 0; i < columnsCount; i++) {
        groups[i] = [];
        for (let p = 0; p < period; p++) {
          const index = period * i + p;
          if (this.columnOneMenu[index]) {
            groups[i].push(this.columnOneMenu[index]);
          }
        }
      }

      return groups;
    },

    columnOneMenu() {
      const content = this.component.variables['column_one_content-text'];
      if (content === MenuTypes.HEADER_MENU) {
        return this.headerMenu;
      }
      return [];
    },

    leftMenu() {
      const half = Math.ceil(this.allMenu[0].length / 2);
      return this.allMenu[0].slice(0, half);
    },
    rightMenu() {
      const half = Math.ceil(this.allMenu[0].length / 2);
      return this.allMenu[0].slice(half);
    },

    logo() {
      if (this.menuVisible) {
        return this.company.logo;
      } else if (this.isScrolled) {
        return this.company.light_logo;
      } else if (!this.vars.fixedColorBool && !this.isScrolled) {
        return this.company.logo;
      }
      return this.company.light_logo;
    },

    navTextColor() {
      if (this.isScrolled) {
        return 'primary';
      }
      return this.vars.navTextColor || 'secondary';
    },
  },

  methods: {
    toggleSubMenu(index) {
      this.openSubMenu = this.openSubMenu === index ? null : index;
    },

    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      if (this.menuVisible) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },

    toggleBurgerMenu() {
      if (!this.menuVisible) {
        const navItems = document.querySelectorAll('.nav-item');
        navItems.forEach((item, index) => {
          setTimeout(() => {
            item.classList.add('nav-item-visible');
          }, index * 150);
        });
      } else {
        const navItems = document.querySelectorAll('.nav-item');
        navItems.forEach((item, index) => {
          setTimeout(
            () => {
              item.classList.remove('nav-item-visible');
            },
            (navItems.length - index) * 150,
          );
        });
        setTimeout(() => {
          this.menuVisible = false;
          document.body.classList.remove('burger-menu-visible');
          document.body.classList.remove('no-scroll');
        }, navItems.length * 150);
        return;
      }

      this.menuVisible = !this.menuVisible;
      document.body.classList.toggle('burger-menu-visible', this.menuVisible);
      if (this.menuVisible) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > this.scrollThreshold;
    },
    toggleTheme() {
      this.isLightMode = !this.isLightMode;
      const htmlElement = document.documentElement;
      htmlElement.classList.toggle('light-mode');

      // Optionally, save the theme preference in localStorage
      if (htmlElement.classList.contains('light-mode')) {
        localStorage.setItem('theme', 'light');
      } else {
        localStorage.setItem('theme', 'dark');
      }
    },

    toggleActiveClass() {
      const burgerMenu = document.querySelector('.burger-menu');
      burgerMenu.classList.toggle('active');
      burgerMenu.querySelectorAll('span').forEach((span) => {
        span.classList.toggle('active');
      });
    },

    closeBurgerMenu() {
      this.menuVisible = false;
      document.body.classList.remove('burger-menu-visible');
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();

    if (this.variants.HEADER_2 === this.variant || this.variants.HEADER_3 === this.variant) {
      const burgerMenu = document.querySelector('.burger-menu');

      if (burgerMenu) {
        burgerMenu.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleBurgerMenu();
        });
      }
    }

    if (this.menuVisible) {
      document.body.classList.add('no-scroll');
    }

    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'light') {
      this.isLightMode = true;
      document.documentElement.classList.add('light-mode');
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    document.body.classList.remove('no-scroll');
  },
});
</script>
<style>
.no-scroll {
  overflow: hidden;
  width: 100%;
}
</style>
<style scoped>
::-webkit-scrollbar {
  display: none;
}

.nav-item {
  transform: translateY(-20px);
  opacity: 0;
  transition: all 0.4s ease-in-out;
}

.nav-item-visible {
  transform: translateY(0);
  opacity: 1;
}

.nav-item-closing {
  animation: fadeOutToBottom 0.4s forwards;
}

@keyframes fadeOutToBottom {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(20px);
    opacity: 0;
  }
}

.nav-menu {
  opacity: 0;
  pointer-events: none;
  transition: all 0.5s ease-in-out;
}

.burger-menu-visible .nav-menu {
  opacity: 1;
  pointer-events: initial;
}

.burger-menu-visible .navbar {
  background-color: transparent !important;
}

button.icon {
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: transparent;
  cursor: pointer;
  align-items: center;
  width: 56px;
  height: 56px;
  justify-content: center;
  border: 1.3px solid inherit;
  border-radius: 8px;
}

button.icon > span {
  height: 2px;
  width: 16px;
  background: inherit;
  border-radius: 30px;
  transition: all 0.3s linear;
}

button.icon > span:nth-child(2) {
  width: 12px;
  margin-left: 3px;
}

/* Hover effects */
button.icon:hover > span {
  width: 11px;
  margin-left: 5px;
}
button.icon.active:hover > span {
  width: 16px;
  margin-left: 0;
}

button.icon:hover > span:nth-child(2) {
  width: 16px;
  margin-left: 0;
}

button.icon.active {
  border-color: #fff !important;
}

button.icon.active > span {
  transform: rotate(45deg);
  margin-bottom: -2px;
}

button.icon.active > span.active {
  background: #fff !important;
}

button.icon.active > span:nth-child(2) {
  width: 16px;
  margin-left: 0;
  margin-top: -5px;
  transform: rotate(-45deg);
  margin-bottom: 0;
}

button.icon span {
  transition: 0.3s ease-in-out;
}

.scrolled {
  animation: fadeIn 0.8s ease-in-out;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    top: -50px;
  }
  to {
    opacity: 1;
    top: 0;
  }
}
</style>
